import React, { Component } from "react";
import { Breadcrumbs, Modal, Paper, Typography, withStyles, Card, CardActions, CardContent } from '@material-ui/core';
import { Button, Row, Col, Form, Container } from 'react-bootstrap';
import moment from 'moment';

const classes = theme => ({
    button: {
        margin: theme.spacing(1),
    },
    extendedIcon: {
        marginRight: theme.spacing(1),
    },
    root: {
        padding: theme.spacing(3, 2),
        minHeight: 470
    },
    modalTitle: {
        marginTop: '20px',
        marginBottom: '20px',
    },
    headerWrapper: {
        display: 'flex',
        flexDirection: 'row-reverse',
        justifyContent: 'space-between'
    },
    buttonsRow: {
        marginTop: '20px',
        marginBottom: '20px',
        textAlign: 'center'
    },
    buttonSubmit: {
        marginTop: '20px'
    }
});


class ProlongarSessao extends Component {
    constructor(props) {
        super(props);
        const { sessionId, dataSessaoFim } = props;

        this.state = {
            sessionId,
            dataSessaoFim,
            dataOriginalSessaoFim: dataSessaoFim
        }
        this.handleAdd30Minutes = this.handleAdd30Minutes.bind(this);
        this.handleAddHour = this.handleAddHour.bind(this);
        this.handleAdd2Hours = this.handleAdd2Hours.bind(this);
        this.handleSaveData = this.handleSaveData.bind(this);
    }

    render() {
        const { classes, handleModalClose } = this.props;
        const { dataOriginalSessaoFim, dataSessaoFim } = this.state;
        const momentData = moment(dataSessaoFim).format("DD/MM/YYYY HH:mm");
        const momentDataDisplay = moment(dataOriginalSessaoFim).format("DD/MM/YYYY HH:mm");

        return (
            <Paper className={classes.root}>
                <Container style={{minWidth: 500}}>
                    <Row>
                        <Col className={classes.headerWrapper}>
                            <Button onClick={() => handleModalClose()} variant="secondary" className="btn-close btn-sm btn-secondary-get">Fechar</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Typography variant="h5" className={classes.modalTitle}>Esta sessão está prevista para encerrar em {momentDataDisplay}</Typography>
                        </Col>
                    </Row>
                    <Row className={classes.buttonsRow}>
                        <Col>
                            <Button size="small" variant="primary-get" onClick={this.handleAdd30Minutes}>+30 min</Button>
                        </Col>
                        <Col>
                            <Button size="small" variant="primary-get" onClick={this.handleAddHour}>+1 hora</Button>
                        </Col>
                        <Col>
                            <Button size="small" variant="primary-get" onClick={this.handleAdd2Hours}>+2 horas</Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <label htmlFor="input-prolongar-ate">Prolongar até:</label>
                            <Form.Control id="input-prolongar-ate" value={momentData} readOnly/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="green" type="submit" onClick={this.handleSaveData} className={classes.buttonSubmit}>Prolongar</Button>
                        </Col>
                    </Row>
                </Container>
            </Paper>
        )
    }

    handleAdd30Minutes() {
        const { dataSessaoFim } = this.state;
        const newDateFim = moment(dataSessaoFim).add(30, 'minutes');
        this.setState({
            dataSessaoFim: newDateFim
        });
    }

    handleAddHour() {
        const { dataSessaoFim } = this.state;
        const newDateFim = moment(dataSessaoFim).add(1, 'hours');
        this.setState({
            dataSessaoFim: newDateFim
        });
    }

    handleAdd2Hours() {
        const { dataSessaoFim } = this.state;
        const newDateFim = moment(dataSessaoFim).add(2, 'hours');
        this.setState({
            dataSessaoFim: newDateFim
        });
    }

    handleSaveData() {
        const { handleModalSaveChange } = this.props;
        const { dataSessaoFim } = this.state;
        
        handleModalSaveChange(dataSessaoFim);
    }

}

export default withStyles(classes)(ProlongarSessao);